import React, { useState } from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  IconButton,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Typography,
  Tooltip,
  Grid,
  Chip,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // MUI Info icon
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import EntityDetailsDropdown from '../../Shared/EntityDropdown/EntityDetailsDropdown.tsx';
import CommonTimePicker from '../../Shared/DateTimePicker/TimePicker.tsx';
import ClearIcon from '@mui/icons-material/Clear';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import { convertToReadableFormat } from '../../../utils/helper.jsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { useMediaQuery } from '@mui/material';

import {
  BLOCKED_EXTENSIONS,
  WHATSAPP_ALLOWED_MIME,
  WHATSAPP_LIMITS,
} from '../../Whatsapp/Template/template.constant.js';
import { spacing } from '../../../theme/tokens/spacing.js';
interface DynamicFormFieldProps {
  item: any;
  index: number;
  onChange: (index: number, value: any, groupTitle: string) => void;
  error?: boolean;
  fieldErrors?: { [key: number]: string };
  helperText?: string;
  groupTitle?: string;
  disabled?: boolean;
}

const getFileNameFromUrl = (url: any) => {
  try {
    if (typeof url === 'string') {
      const fileName = url?.split('/')?.pop() ?? '';
      return fileName;
    }
    if (url && typeof url === 'object' && url.name) {
      return url.name;
    }
    return '';
  } catch (err) {
    return '';
  }
};

const DynamicFormField: React.FC<DynamicFormFieldProps> = ({
  item,
  index,
  groupTitle = '',
  onChange,
  fieldErrors,
  disabled = false,
}) => {
  console.log("items", item)
  const compositeKey = `${groupTitle}_${index}`;
  const [showHideFileUpload, setShowHideFileUpload] = useState({});
  const { showSnackBar } = useSnackBar();
  const [localValue, setLocalValue] = React.useState(item.value || '');
  const [showPassword, setShowPassword] = useState(false);
  const fileInputRef = React.useRef<HTMLInputElement | null>(null);

  const handleChange = (value: any) => {
    onChange(index, value, groupTitle);
  };
  const isStatusField = (f?: any) => f?.statusOption === 'is_status';
  const isSubStatusField = (f?: any) => f?.statusOption === 'is_sub_status';

  React.useEffect(() => {
    setLocalValue(item.value || '');
  }, [item.value]);

  const labelWithRequired = (
    <span>
      {item.alias_name || item.key_name}
      {item.is_required && <span style={{ color: 'red' }}> *</span>}
    </span>
  );
  const isPermissionView = item?.access_level === 'view';
  const isFieldDisabled = isPermissionView || disabled;

const isTouchDevice = useMediaQuery('(hover: none)');
const [tooltipOpen, setTooltipOpen] = useState(false);

  switch (item.key_type) {
    case 'STRING':
    case 'EMAIL':
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            fullWidth
            size="small"
            type={
              item.key_type === 'EMAIL' ? 'email' : item.key_type === 'FLOAT' ? 'number' : 'text'
            }
            label={labelWithRequired}
            // value={item.value || ''}
            value={localValue}
            disabled={item?.is_primary || isFieldDisabled}
            // onChange={(e) => handleChange(e.target.value)}
            onChange={(e) => {
              setLocalValue(e.target.value);
              handleChange(e.target.value);
            }}
            error={!item.is_primary && !!fieldErrors?.[compositeKey]}
            helperText={!item.is_primary && fieldErrors?.[compositeKey]}
            autoComplete="off"
            inputProps={{
              autoComplete: 'off',
            }}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#EAEAEA !important',
              },
              '& .MuiInputBase-root':{overflow: 'hidden'},
            }}
          />
          {item?.isSuggestion && (
              <Tooltip
                title={item?.suggestionMsg || ''}
                placement="top"
                arrow
                {...(isTouchDevice && {
                  open: tooltipOpen,
                  onClose: () => setTooltipOpen(false),
                  disableHoverListener: true,
                  disableFocusListener: true,
                  disableTouchListener: true,
                })}
                >
                <IconButton
                  size="small"
                  sx={{ ml: 1 }}
                  onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                >
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
          )}
        </Box>
      );
    case 'PHONE':
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            fullWidth
            size="small"
            label={labelWithRequired}
            // value={item.value || ''}
            value={localValue}
            disabled={item?.is_primary || isFieldDisabled}
            // onChange={(e) => {
            //   const value = e.target.value.replace(/\D/g, '');
            //   handleChange(value);
            // }}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              setLocalValue(value);
              handleChange(value);
            }}
            error={!!fieldErrors?.[compositeKey]}
            helperText={fieldErrors?.[compositeKey]}
            inputProps={{
              maxLength: 12,
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
            }}
          />
          {item?.isSuggestion && (
              <Tooltip
                title={item?.suggestionMsg || ''}
                placement="top"
                arrow
                {...(isTouchDevice && {
                  open: tooltipOpen,
                  onClose: () => setTooltipOpen(false),
                  disableHoverListener: true,
                  disableFocusListener: true,
                  disableTouchListener: true,
                })}
                >
                <IconButton
                  size="small"
                  sx={{ ml: 1 }}
                  onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                >
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
          )}
        </Box>
      );
    case 'FLOAT':
    case 'INT':
    case 'PINCODE':
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            fullWidth
            size="small"
            label={labelWithRequired}
            // value={item.value || ''}
            value={localValue}
            disabled={item?.is_primary || isFieldDisabled}
            onChange={(e) => {
              let value = e.target.value;

              if (item.key_type === 'INT' || item.key_type === 'PINCODE') {
                value = value.replace(/\D/g, '');
                if (item.key_type === 'PINCODE' && value.length > 6) {
                  value = value.slice(0, 6);
                }
              }

              if (item.key_type === 'FLOAT') {
                value = value.replace(/[^0-9.]/g, '');
                if ((value.match(/\./g) || []).length > 1) {
                  value = value.replace(/\.+$/, '');
                }
              }
              setLocalValue(value);
              handleChange(value ? Number(value) : '');
              // handleChange(Number(value));
            }}
            error={!!fieldErrors?.[compositeKey]}
            helperText={fieldErrors?.[compositeKey]}
            inputProps={{
              maxLength: item.key_type === 'PINCODE' ? 6 : 100,
              inputMode: item.key_type === 'FLOAT' ? 'decimal' : 'numeric',
              pattern: item.key_type === 'FLOAT' ? '[0-9]*([\\.][0-9]*)?' : '[0-9]*',
            }}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
            }}
          />
          {item?.isSuggestion && (
              <Tooltip
                title={item?.suggestionMsg || ''}
                placement="top"
                arrow
                {...(isTouchDevice && {
                  open: tooltipOpen,
                  onClose: () => setTooltipOpen(false),
                  disableHoverListener: true,
                  disableFocusListener: true,
                  disableTouchListener: true,
                })}
                >
                <IconButton
                  size="small"
                  sx={{ ml: 1 }}
                  onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                >
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
          )}
        </Box>
      );

    case 'PASSWORD':
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            fullWidth
            size="small"
            type={showPassword ? 'text' : 'password'}
            label={labelWithRequired}
            // value={item.value || ''}
            value={localValue}
            disabled={item?.is_primary || isFieldDisabled}
            // onChange={(e) => handleChange(e.target.value)}
            onChange={(e) => {
              setLocalValue(e.target.value);
              handleChange(e.target.value);
            }}
            error={!item.is_primary && !!fieldErrors?.[compositeKey]}
            helperText={!item.is_primary && fieldErrors?.[compositeKey]}
            autoComplete="new-password"
            inputProps={{
              autoComplete: 'new-password',
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword((prev) => !prev)}
                    onMouseDown={(e) => e.preventDefault()}
                    edge="end"
                    size="small"
                  >
                    {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
            }}
          />
          {item?.isSuggestion && (
              <Tooltip
                title={item?.suggestionMsg || ''}
                placement="top"
                arrow
                {...(isTouchDevice && {
                  open: tooltipOpen,
                  onClose: () => setTooltipOpen(false),
                  disableHoverListener: true,
                  disableFocusListener: true,
                  disableTouchListener: true,
                })}
                >
                <IconButton
                  size="small"
                  sx={{ ml: 1 }}
                  onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                >
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
          )}
        </Box>
      );

    case 'TEXT':
    case 'CUSTOM':
    case 'TEXTAREA':
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            fullWidth
            size="small"
            label={labelWithRequired}
            multiline
            // value={item.value || ''}
            value={localValue}
            onChange={(e) => {
              setLocalValue(e.target.value);
              handleChange(e.target.value);
            }}
            error={!!fieldErrors?.[compositeKey] || false}
            helperText={fieldErrors?.[compositeKey] || ''}
            disabled={isFieldDisabled}
            inputProps={{
              maxLength: item?.maxLength || 10000,
              minLength: item?.minLength || 0,
            }}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
              '& .MuiInputLabel-shrink': {
                top: '-2.1px !important '
              },

            }}
          // sx={{
          //   '& .MuiInputBase-input.Mui-disabled': {
          //     WebkitTextFillColor: '#000000',
          //     color: '#000000',
          //     opacity: 1,
          //   },
          //   '& .MuiInputLabel-root.Mui-disabled': {
          //     color: '#000000',
          //     opacity: 1,
          //   },
          // }}
          />
          {item?.isSuggestion && (
            <Tooltip
                title={item?.suggestionMsg || ''}
                placement="top"
                arrow
                {...(isTouchDevice && {
                  open: tooltipOpen,
                  onClose: () => setTooltipOpen(false),
                  disableHoverListener: true,
                  disableFocusListener: true,
                  disableTouchListener: true,
                })}
                >
                <IconButton
                  size="small"
                  sx={{ ml: 1 }}
                  onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                >
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
          )}
        </Box>
      );
    case 'BOOLEAN':
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <FormControl
            component="fieldset"
            disabled={isFieldDisabled}
            error={!!fieldErrors?.[compositeKey]}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
              width: '100%',
            }}
          >
            <FormControlLabel
              control={
                <Switch checked={!!item.value} onChange={(e) => handleChange(e.target.checked)} />
              }
              label={
                <Box>
                  <span>{labelWithRequired}</span>
                  {item?.isSuggestion && (
                    <Tooltip
                      title={item?.suggestionMsg || ''}
                      placement="top"
                      arrow
                      {...(isTouchDevice && {
                        open: tooltipOpen,
                        onClose: () => setTooltipOpen(false),
                        disableHoverListener: true,
                        disableFocusListener: true,
                        disableTouchListener: true,
                      })}
                      >
                      <IconButton
                        size="small"
                        sx={{ ml: 0 , paddingRight: '26px'}}
                        onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                      >
                        <InfoOutlinedIcon fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
              }
            />
            {fieldErrors?.[compositeKey] && (
              <FormHelperText>{fieldErrors[compositeKey]}</FormHelperText>
            )}
          </FormControl>
        </Box>
      );
    case 'DATE': {
      const parseAnyDate = (val: string): Date | null => {
        if (!val) return null;
        const str = String(val).trim();

        let m = str.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
        if (m) {
          const [, y, mo, d] = m;
          const dt = new Date(Number(y), Number(mo) - 1, Number(d));
          return isNaN(dt.getTime()) ? null : dt;
        }

        m = str.match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})/);
        if (m) {
          let [, d, mo, y] = m;
          if (y.length === 2) y = `20${y}`; // handle 2-digit year
          const day = Number(d);
          const month = Number(mo);
          const finalDay = month > 12 ? Number(mo) : day;
          const finalMonth = month > 12 ? day : month;
          const dt = new Date(Number(y), finalMonth - 1, finalDay);
          return isNaN(dt.getTime()) ? null : dt;
        }

        const fallback = new Date(str);
        return isNaN(fallback.getTime()) ? null : fallback;
      };

      const toInputDate = (val: string): string => {
        const dt = parseAnyDate(val);
        if (!dt) return '';
        const yyyy = dt.getFullYear();
        const mm = String(dt.getMonth() + 1).padStart(2, '0');
        const dd = String(dt.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      };

      const toDisplayDate = (isoVal: string): string => {
        if (!isoVal) return '';
        const [yyyy, mm, dd] = isoVal.split('-');
        return `${dd}/${mm}/${yyyy}`;
      };

      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            fullWidth
            size="small"
            type="date"
            label={labelWithRequired}
            InputLabelProps={{ shrink: true }}
            value={toInputDate(item.value)}
            onChange={(e) => handleChange(toDisplayDate(e.target.value))}
            error={!item.is_primary && !!fieldErrors?.[compositeKey]}
            helperText={!item.is_primary && fieldErrors?.[compositeKey]}
            disabled={isFieldDisabled}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
              '& .MuiInputBase-root':{overflow: 'hidden'},
            }}
          />
          {item?.isSuggestion && (
            <Tooltip
              title={item?.suggestionMsg || ''}
              placement="top"
              arrow
              {...(isTouchDevice && {
                open: tooltipOpen,
                onClose: () => setTooltipOpen(false),
                disableHoverListener: true,
                disableFocusListener: true,
                disableTouchListener: true,
              })}
              >
              <IconButton
                size="small"
                sx={{ ml: 1}}
                onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
              >
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
    }
    // case 'DATE':
    //   return (
    //     <Box display="flex" alignItems="center" justifyContent="space-between">
    //       <TextField
    //         fullWidth
    //         size="small"
    //         type={'date'}
    //         label={labelWithRequired}
    //         InputLabelProps={{ shrink: true }}
    //         value={item.value || ''}
    //         onChange={(e) => handleChange(e.target.value)}
    //         error={!item.is_primary && !!fieldErrors?.[compositeKey]}
    //         helperText={!item.is_primary && fieldErrors?.[compositeKey]}
    //         disabled={isFieldDisabled}
    //         sx={{
    //           '& .MuiInputBase-input.Mui-disabled': {
    //             WebkitTextFillColor: '#000000 !important',
    //             color: '#000000 !important',
    //             opacity: '1 !important',
    //           },
    //           '& .MuiInputLabel-root.Mui-disabled': {
    //             color: '#000000 !important',
    //             opacity: '1 !important',
    //           },
    //           '& .MuiOutlinedInput-root.Mui-disabled': {
    //             backgroundColor: '#f5f5f5 !important',
    //             borderColor: '#ccc !important',
    //           },
    //         }}
    //       />
    //       {item?.isSuggestion && (
    //         <Tooltip title={item?.suggestionMsg || ''} placement="top" arrow>
    //           <IconButton size="small" sx={{ ml: 0 }}>
    //             <InfoOutlinedIcon fontSize="inherit" />
    //           </IconButton>
    //         </Tooltip>
    //       )}
    //     </Box>
    //   );
    case 'TIME':
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <CommonTimePicker
            label={labelWithRequired}
            value={item?.value || null}
            onChange={(e) => {
              handleChange(e);
            }}
            error={!item.is_primary && !!fieldErrors?.[compositeKey]}
            helperText={!item.is_primary && fieldErrors?.[compositeKey]}
            // sx={{
            //   '& .MuiInputBase-input.Mui-disabled': {
            //     WebkitTextFillColor: '#000000 !important',
            //     color: '#000000 !important',
            //     opacity: '1 !important',
            //   },
            //   '& .MuiInputLabel-root.Mui-disabled': {
            //     color: '#000000 !important',
            //     opacity: '1 !important',
            //   },
            //   '& .MuiOutlinedInput-root.Mui-disabled': {
            //     backgroundColor: '#f5f5f5 !important',
            //     borderColor: '#ccc !important',
            //   },
            // }}
            disabled={isFieldDisabled}
          />
          {item?.isSuggestion && (
            <Tooltip
              title={item?.suggestionMsg || ''}
              placement="top"
              arrow
              {...(isTouchDevice && {
                open: tooltipOpen,
                onClose: () => setTooltipOpen(false),
                disableHoverListener: true,
                disableFocusListener: true,
                disableTouchListener: true,
              })}
              >
              <IconButton
                size="small"
                sx={{ ml: 1 }}
                onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
              >
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );

    case 'FILE': {
      const inferDocType = (mime: string): 'image' | 'video' | 'audio' | 'file' | null => {
        if (WHATSAPP_ALLOWED_MIME.image.includes(mime)) return 'image';
        if (WHATSAPP_ALLOWED_MIME.video.includes(mime)) return 'video';
        if (WHATSAPP_ALLOWED_MIME.audio.includes(mime)) return 'audio';
        if (WHATSAPP_ALLOWED_MIME.file.includes(mime)) return 'file';
        return null;
      };
      const bytesToMB = (bytes: number) => (bytes / (1024 * 1024)).toFixed(2);

      // const fileInputRef = React.useRef<HTMLInputElement>(null);

      // const validateFile = (file: File) => {
      //   if (!file) return true;
      //   if (!allowedFileTypes.includes(file.type)) {
      //     showSnackBar(
      //       'File type not allowed. Please upload a valid file (images, documents, audio, or video).',
      //       'error'
      //     );
      //     return false;
      //   }
      //   return true;
      // };
      // const validateFile = (file: File) => {
      //   if (!file) return true;
      //   const fileName = file.name.toLowerCase();
      //   const ext = fileName.split('.').pop();
      //   if (BLOCKED_EXTENSIONS.has(ext)) {
      //     showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
      //     return false;
      //   }

      //   const typeGroup = inferDocType(file.type);
      //   if (!typeGroup) {
      //     showSnackBar(`Unsupported file type (${file.type || ext}).`, 'error');
      //     return false;
      //   }

      //   const limit = WHATSAPP_LIMITS[typeGroup];
      //   if (file.size > limit) {
      //     showSnackBar(
      //       `File too large for ${typeGroup}. Max ${bytesToMB(limit)} MB. Your file is ${bytesToMB(file.size)} MB.`,
      //       'error'
      //     );
      //     return false;
      //   }

      //   return true;
      // };
      const validateFile = (file: File) => {
        if (!file) return false;

        // Check for empty / 0-byte file
        if (!file.size || file.size <= 0) {
          showSnackBar('File cannot be empty (0 bytes).', 'error');
          return false;
        }

        const fileName = file.name.toLowerCase();
        const ext = fileName.split('.').pop();
        const mime = file.type;

        if (BLOCKED_EXTENSIONS.has(ext)) {
          showSnackBar(`"${ext}" files are not allowed for security reasons.`, 'error');
          return false;
        }

        const allowedFileTypes = [
          'image/jpeg',
          'image/png',
          'image/gif',
          'image/webp',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'audio/mpeg',
          'audio/wav',
          'audio/ogg',
          'audio/aac',
          'audio/webm',
          'video/mp4',
          'video/webm',
          'video/ogg',
          'video/x-msvideo',
        ];

        if (!allowedFileTypes.includes(mime)) {
          showSnackBar(`Unsupported file type: ${ext || mime}`, 'error');
          return false;
        }

        // ✅ Check size limit (customize per type if you like)
        const maxFileSize = 10 * 1024 * 1024; // 10 MB
        if (file.size > maxFileSize) {
          showSnackBar(`File too large. Max 10 MB allowed.`, 'error');
          return false;
        }

        return true;
      };

      const handleFileClear = () => {
        handleChange(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      };

      return (
        <Box key={compositeKey} sx={{ mb: 2 }}>
          {/* 🔹 VIEW MODE → show only link */}
          {isPermissionView ? (
            <Box>
              {/* Always show alias/label */}
              <Typography fontWeight={500} mb={0.5}>
                {convertToReadableFormat(item?.alias_name)}
              </Typography>

              {/* Then show file or fallback */}
              {item?.value ? (
                <Typography variant="body2" color="primary">
                  <a href={item?.value} target="_blank" rel="noopener noreferrer">
                    {getFileNameFromUrl(item?.value) ?? 'View File'}
                  </a>
                </Typography>
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No file uploaded
                </Typography>
              )}
            </Box>
          ) : (
            <>
              {/* 🔹 EDIT MODE → Switch + Upload/URL input */}
              <FormControlLabel sx={{ marginBottom: spacing.size1 }}
                control={
                  <Switch
                    checked={showHideFileUpload[item?.alias_name] ?? false}
                    onChange={(e) => {
                      setShowHideFileUpload((prevItems: any) => ({
                        ...prevItems,
                        [item?.alias_name]: e.target.checked,
                      }));
                      handleFileClear();
                    }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    size="small"
                  />
                }
                // label={
                //   showHideFileUpload[item?.alias_name]
                //     ? `Paste ${convertToReadableFormat(item?.alias_name) ?? ''} URL`
                //     : `Upload ${convertToReadableFormat(item?.alias_name) ?? ''}`
                // }
                label={
                  <span>
                    {showHideFileUpload[item?.alias_name]
                      ? `Paste ${convertToReadableFormat(item?.alias_name) ?? ''} URL`
                      : `Upload ${convertToReadableFormat(item?.alias_name) ?? ''}`}
                    {item.is_required && <span style={{ color: 'red' }}> *</span>}
                  </span>
                }
              />

              {/* URL input */}
              {showHideFileUpload[item?.alias_name] && (
                <TextField
                  id={`${item?.alias_name}-link`}
                  name={`${item?.alias_name}-link`}
                  type="url"
                  label={`Paste a direct ${item?.key_type ?? ''} link`}
                  value={item?.value ?? ''}
                  onChange={(e: any) => handleChange(e.target.value)}
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{ mt: 1 }}
                  required={item?.is_required ?? false}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        edge="end"
                        onClick={async () => {
                          try {
                            const url = await navigator.clipboard.readText();
                            handleChange(url);
                          } catch (err) {
                            console.error('Clipboard read failed', err);
                          }
                        }}
                      >
                        <ContentPasteIcon />
                      </IconButton>
                    ),
                  }}
                />
              )}

              {/* File upload */}
              {!showHideFileUpload[item?.alias_name] && (
                <>
                  {item?.value && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                      <Typography variant="body2" color="primary">
                        {typeof item?.value === 'string' ? (
                          <a href={item?.value} target="_blank" rel="noopener noreferrer">
                            {getFileNameFromUrl(item?.value) || 'File'}
                          </a>
                        ) : (
                          <span>{item?.value?.name || 'File'}</span>
                        )}
                      </Typography>
                      <IconButton size="small" onClick={handleFileClear}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                  <TextField
                    inputRef={fileInputRef}
                    id={`${item?.alias_name}-file`}
                    name={`${item?.alias_name}-file`}
                    type="file"
                    error={!!fieldErrors?.[compositeKey]}
                    onChange={(e: any) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      if (!validateFile(file)) {
                        e.target.value = '';
                        if (fileInputRef.current) {
                          fileInputRef.current.value = '';
                        }
                        handleChange(null);
                        return;
                      }
                      handleChange(file);
                    }}
                    variant="outlined"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      fieldErrors?.[compositeKey] ||
                      'Allowed formats: Images , PDF, Word, Excel, Audio, Video -  • Max 10 MB'
                    }
                  />
                </>
              )}
              {fieldErrors?.[compositeKey] && (
                <FormHelperText error>{fieldErrors[compositeKey]}</FormHelperText>
              )}
            </>
          )}
        </Box>
      );
    }

    case 'CHECKBOX':
      return (
        <Box display="flex" alignItems="flex-start" gap={1}>
          <FormControl
            component="fieldset"
            error={!!fieldErrors?.[compositeKey]}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
              width: '100%',
            }}
            disabled={isFieldDisabled}
          >
            <Typography fontWeight={500} mb={0}>
              {labelWithRequired}
              {item?.isSuggestion && (
                <Tooltip
                  title={item?.suggestionMsg || ''}
                  placement="top"
                  arrow
                  {...(isTouchDevice && {
                    open: tooltipOpen,
                    onClose: () => setTooltipOpen(false),
                    disableHoverListener: true,
                    disableFocusListener: true,
                    disableTouchListener: true,
                  })}
                  >
                  <IconButton
                    size="small"
                    sx={{ ml: 1}}
                    onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                  >
                    <InfoOutlinedIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              )}
            </Typography>

            <FormGroup row sx={{ gap: 0.5 }}>
              {(item.key_options || []).map((option: string) => (
                <FormControlLabel
                  key={option + groupTitle}
                  sx={{ p: 0.3 }}
                  control={
                    <Checkbox
                      size="small"
                      sx={{ px: 1.5, py: 0.5 }}
                      checked={Array.isArray(item.value) && item.value.includes(option)}
                      onChange={(e) => {
                        const updated = Array.isArray(item.value) ? [...item.value] : [];
                        if (e.target.checked) {
                          if (!updated.includes(option)) updated.push(option);
                        } else {
                          const idx = updated.indexOf(option);
                          if (idx !== -1) updated.splice(idx, 1);
                        }
                        handleChange(updated);
                      }}
                      disabled={isFieldDisabled}
                    />
                  }
                  label={
                    <Chip
                      label={option}
                      variant="outlined"
                      size="small"
                      color={
                        Array.isArray(item.value) && item.value.includes(option)
                          ? 'primary'
                          : 'default'
                      }
                    />
                  }
                />
              ))}
            </FormGroup>

            {fieldErrors?.[compositeKey] && (
              <FormHelperText>{fieldErrors[compositeKey]}</FormHelperText>
            )}
          </FormControl>
        </Box>
      );

    case 'RADIO':
      return (
        <Box sx={{mb:0.5}}>
          <Typography fontWeight={500} mb={0.8}>
            {' '}
            {labelWithRequired}{' '}
            {item?.isSuggestion && (
              <Tooltip
                title={item?.suggestionMsg || ''}
                placement="top"
                arrow
                {...(isTouchDevice && {
                  open: tooltipOpen,
                  onClose: () => setTooltipOpen(false),
                  disableHoverListener: true,
                  disableFocusListener: true,
                  disableTouchListener: true,
                })}
               >
                <IconButton
                  size="small"
                  sx={{ ml: 1}}
                  onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                >
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            )}
          </Typography>
          <RadioGroup
            row
            sx={{ gap: 0.25}}
            value={item?.value || ''}
            onChange={(e) => handleChange(e.target.value)}
          >
            {(item.key_options || []).map((option: string) => (
              <FormControlLabel
                sx={{ p: 0 }}
                key={`${item?.alias_name}_${option}`}
                value={option}
                control={<Radio sx={{ pl: 0, pr: 1.5, py: 0.5 }} size="small" />}
                label={
                  <Chip
                    label={option}
                    variant="outlined"
                    size="small"
                    color={item?.value === option ? 'primary' : 'default'}
                  />
                }
              />
            ))}
          </RadioGroup>
          {fieldErrors?.[compositeKey] && (
            <FormHelperText>{fieldErrors[compositeKey]}</FormHelperText>
          )}
        </Box>
      );

    case 'DROPDOWN': {
      if (isStatusField(item)) {
        return (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <SearchableDropdown
              label={labelWithRequired}
              value={
                Array.isArray(item?.key_options)
                  ? item.key_options.find(
                    (status: any) =>
                      status?.status_id === item?.status_config?.status_id ||
                      status?.status_name === item?.value ||
                      status?.status_id === item?.value
                  ) ?? null
                  : null
              }
              onChange={(selectedOption) => {
                handleChange(selectedOption ?? '');
              }}
              labelKey="status_name"
              valueKey="status_id"
              options={Array.isArray(item?.key_options) ? item.key_options : []}
              size="small"
              disabled={isFieldDisabled}
            />
          </Box>
        );
      }

      if (isSubStatusField(item)) {
        // SUB-STATUS: options = [{ sub_status_id, name, status_id, status_name, type_of_status }]
        return (
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <SearchableDropdown
              label={labelWithRequired}
              value={
                Array.isArray(item?.key_options)
                  ? item.key_options.find(
                    (sub: any) =>
                      sub?.sub_status_id === item?.status_config?.sub_status_id ||
                      sub?.name === item?.value ||
                      sub?.sub_status_id === item?.value
                  ) ?? null
                  : null
              }
              onChange={(selectedOption) => {
                let data = null;
                if (selectedOption) {
                  data = { ...selectedOption };
                }
                handleChange(data ?? '');
              }}
              labelKey="name"
              valueKey="sub_status_id"
              options={Array.isArray(item?.key_options) ? item?.key_options : []}
              size="small"
              disabled={isFieldDisabled}
            />
          </Box>
        );
      }

      // Plain dropdown
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            fullWidth
            select
            size="small"
            label={labelWithRequired}
            // value={item.value || ''}
            value={localValue}
            // onChange={(e) => handleChange(e.target.value)}
            onChange={(e) => {
              setLocalValue(e.target.value);
              handleChange(e.target.value);
            }}
            error={!item.is_primary && !!fieldErrors?.[compositeKey]}
            helperText={!item.is_primary && fieldErrors?.[compositeKey]}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
            }}
            disabled={isFieldDisabled}
          >
            {(item.key_options || []).map((option: string, idx: number) => (
              <MenuItem key={idx} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
          {item?.isSuggestion && (
            <Tooltip
              title={item?.suggestionMsg || ''}
              placement="top"
              arrow
              {...(isTouchDevice && {
                open: tooltipOpen,
                onClose: () => setTooltipOpen(false),
                disableHoverListener: true,
                disableFocusListener: true,
                disableTouchListener: true,
              })}
             >
              <IconButton
                size="small"
                sx={{ ml: 1}}
                onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
              >
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
    }

    case 'ENTITY':
      return (
        <>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <EntityDetailsDropdown
              entityFormId={item?.entity?._id}
              selectedEntityFields={item?.selectedEntityFields || []}
              value={item?.entity_data || null}
              queryParams={item?.query_parameter || []}
              autoSelect={true}
              onChange={(selectedOption) => {
                let data = {
                  collection: 'entity',
                  _id: '',
                  value: '',
                };
                if (!selectedOption) {
                  handleChange(data);
                  return;
                }
                data._id = selectedOption?._id ?? '';
                data.value = selectedOption?.value ?? '';
                handleChange(data ?? '');
              }}
              label={
                <Typography component="span">
                  {item.alias_name}
                  {item.is_required && <span style={{ color: 'red' }}>*</span>}
                </Typography>
              }
              error={!item.is_primary && !!fieldErrors?.[compositeKey]}
              sx={{
                '& .MuiInputLabel-shrink': {
                  top: '-3.8px !important '
                },
                '& .MuiFormLabel-root.MuiInputLabel-root': {
                  top: '0px',
                },
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: '#000000 !important',
                  color: '#000000 !important',
                  opacity: '1 !important',
                },
                '& .MuiInputLabel-root.Mui-disabled': {
                  color: '#000000 !important',
                  opacity: '1 !important',
                },
                '& .MuiOutlinedInput-root.Mui-disabled': {
                  backgroundColor: '#f5f5f5 !important',
                  borderColor: '#ccc !important',
                },
              }}
              disabled={isFieldDisabled}
            />

            {item?.isSuggestion && (
              <Tooltip
                title={item?.suggestionMsg || ''}
                placement="top"
                arrow
                {...(isTouchDevice && {
                  open: tooltipOpen,
                  onClose: () => setTooltipOpen(false),
                  disableHoverListener: true,
                  disableFocusListener: true,
                  disableTouchListener: true,
                })}
                >
                <IconButton
                  size="small"
                  sx={{ ml: 1}}
                  onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
                >
                  <InfoOutlinedIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
            )}
          </Box>
        </>
      );
    case 'CITY':
      return (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{
            width: '100%',
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: '#000000',
              color: '#000000',
              opacity: 1,
            },
            '& .MuiInputLabel-root.Mui-disabled': {
              color: '#000000',
              opacity: 1,
            },
          }}
        >
          <TextField
            fullWidth
            select
            size="small"
            label={labelWithRequired}
            value={item.value || ''}
            onChange={(e) => handleChange(e.target.value)}
            error={!item.is_primary && !!fieldErrors?.[compositeKey]}
            helperText={!item.is_primary && fieldErrors?.[compositeKey]}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
            }}
            disabled={isFieldDisabled}
          >
            {(item.key_options || []).map((option: string, idx: number) => (
              <MenuItem key={idx} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
          {item?.isSuggestion && (
            <Tooltip
              title={item?.suggestionMsg || ''}
              placement="top"
              arrow
              {...(isTouchDevice && {
                open: tooltipOpen,
                onClose: () => setTooltipOpen(false),
                disableHoverListener: true,
                disableFocusListener: true,
                disableTouchListener: true,
              })}
              >
              <IconButton
                size="small"
                sx={{ ml: 1}}
                onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
              >
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
    default:
      return (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <TextField
            fullWidth
            size="small"
            label={labelWithRequired}
            value={item.value || ''}
            onChange={(e) => handleChange(e.target.value)}
            error={!item.is_primary && !!fieldErrors?.[compositeKey]}
            helperText={!item.is_primary && fieldErrors?.[compositeKey]}
            sx={{
              '& .MuiInputBase-input.Mui-disabled': {
                WebkitTextFillColor: '#000000 !important',
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiInputLabel-root.Mui-disabled': {
                color: '#000000 !important',
                opacity: '1 !important',
              },
              '& .MuiOutlinedInput-root.Mui-disabled': {
                backgroundColor: '#f5f5f5 !important',
                borderColor: '#ccc !important',
              },
            }}
            disabled={isFieldDisabled}
          />
          {item?.isSuggestion && (
            <Tooltip
              title={item?.suggestionMsg || ''}
              placement="top"
              arrow
              {...(isTouchDevice && {
                open: tooltipOpen,
                onClose: () => setTooltipOpen(false),
                disableHoverListener: true,
                disableFocusListener: true,
                disableTouchListener: true,
              })}
             >
              <IconButton
                size="small"
                sx={{ ml: 1}}
                onClick={ isTouchDevice ? () => { setTooltipOpen(true); setTimeout(() => { setTooltipOpen(false); }, 1000); } : undefined }
              >
                <InfoOutlinedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
  }
};
export default DynamicFormField;
